export default __webpack_public_path__ + "static/media/awsDevBadge.6b2fe073.png";